import Vue from "vue";
import Router from "vue-router";
import { getLanguage } from "./lang/index";

var lang;
switch (getLanguage()) {
  case "en":
    lang = require("./lang/en.js").default;
    break;
  case "zh":
    lang = require("./lang/zh.js").default;
    break;
  default:
    lang = require("./lang/zh.js").default;
}

Vue.use(Router);
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "homeNew",
      component: _ => import("./views/homeNew/homeNew.vue"),
      meta: {
        title: "Vancheen B2B"
      }
    },
    {
      path: "/old",
      name: "b2bOld",
      component: _ => import("./views/b2b/home.vue"),
      meta: {
        title: "Vancheen B2B"
      }
    },
    {
      path: "/about",
      name: "aboutNew",
      component: _ => import("./views/homeNew/pages/NhAboutPage.vue"),
      meta: {
        title: "About Us — T&W"
      }
    },
    {
      path: "/products",
      name: "productsNew",
      component: _ => import("./views/homeNew/pages/NhProductsPage.vue"),
      meta: {
        title: "Products — T&W"
      }
    },
    {
      path: "/factory",
      name: "factoryNew",
      component: _ => import("./views/homeNew/pages/NhFactoryPage.vue"),
      meta: {
        title: "Factory Tour — T&W"
      }
    },
    {
      path: "/quality",
      name: "qualityNew",
      component: _ => import("./views/homeNew/pages/NhQualityPage.vue"),
      meta: {
        title: "Quality Control — T&W"
      }
    },
    {
      path: "/news",
      name: "newsNew",
      component: _ => import("./views/homeNew/pages/NhNewsPage.vue"),
      meta: {
        title: "News & Events — T&W"
      }
    },
    {
      path: "/home",
      name: "home",
      component: _ => import("./views/home/home.vue"),
      meta: {
        title: "Vancheen"
      }
    },
    {
      path: "/activate",
      name: "activate",
      component: _ => import("./views/supplier/activate.vue"),
      meta: {
        title: lang.meta.title1
      }
    },
    {
      path: "/login",
      name: "login",
      component: _ => import("./views/Login.vue"),
      meta: {
        title: lang.meta.title2
      }
    },
    {
      path: "/register",
      component: _ => import("./views/Register.vue"),
      meta: {
        title: lang.meta.title3
      }
    },
    {
      path: "/forget",
      component: _ => import("./views/Forget.vue"),
      meta: {
        title: lang.meta.title4
      }
    },
    {
      path: "/messageList",
      component: _ => import("./views/messageList.vue"),
      meta: {
        title: lang.meta.title5
      }
    },
    {
      path: "/details",
      component: _ => import("./views/detail/Details.vue"),
      meta: {
        title: lang.meta.title6
      }
    },
    {
      path: "/store",
      component: _ => import("./views/store/Store.vue"),
      meta: {
        title: lang.meta.title7
      }
    },
    {
      path: "/search",
      component: _ => import("./views/search/Search.vue"),
      meta: {
        title: lang.meta.title8
      }
    },
    {
      path: "/authentication",
      name: "authentication",
      component: _ => import("./views/cUser/authentication.vue"),
      meta: {
        requireAuth: true,
        title: lang.meta.title9
      }
    },
    {
      path: "/catalog",
      name: "catalog",
      component: _ => import("./views/b2b/catalog.vue"),
      meta: {
        title: "B2B " + lang.meta.title10
      }
    },
    {
      path: "/topProduct",
      name: "topProduct",
      component: _ => import("./views/b2b/topProduct.vue"),
      meta: {
        title: "B2B " + lang.meta.title11
      }
    },
    {
      path: "/public",
      name: "public",
      component: _ => import("./views/b2b/public.vue"),
      meta: {
        title: "B2B " + lang.meta.title12
      }
    },
    {
      path: "/business",
      name: "business",
      component: _ => import("./views/b2b/business.vue"),
      meta: {
        title: "B2B " + lang.meta.title13
      }
    },
    {
      path: "/commodity",
      name: "commodity",
      component: _ => import("./views/b2b/commodity.vue"),
      meta: {
        title: "B2B " + lang.meta.title14
      }
    },
    {
      path: "/commodityEdit",
      name: "commodityEdit",
      component: _ => import("./views/b2b/commodityEdit.vue"),
      meta: {
        title: "B2B " + lang.meta.title15
      }
    },
    {
      path: "/enquiry",
      name: "enquiry",
      component: _ => import("./views/b2b/enquiry.vue"),
      meta: {
        title: "B2B " + lang.meta.title16
      }
    },
    {
      path: "/adminLogin",
      name: "adminLogin",
      component: _ => import("./views/b2b/adminLogin.vue"),
      meta: {
        title: "B2B " + lang.meta.title17
      }
    },
    {
      path: "/cUser",
      component: _ => import("./views/cUser/Index.vue"),
      children: [
        {
          path: "/",
          component: _ => import("./views/cUser/default.vue"),
          meta: {
            title: "Vancheen " + lang.meta.title18
          }
        },
        {
          path: "cOrders",
          name: "cOrders",
          component: _ => import("./views/cUser/order/cOrders.vue"),
          meta: {
            title: lang.meta.title19
          }
        },
        {
          path: "cOrderInfo",
          name: "cOrderInfo",
          component: _ => import("./views/cUser/order/cOrderInfo.vue"),
          meta: {
            title: lang.meta.title19
          }
        },
        {
          path: "userManage",
          name: "UserManage",
          component: _ => import("./views/cUser/UserManage.vue"),
          meta: {
            title: lang.meta.title20
          }
        },
        {
          path: "goodsAttention",
          name: "goodsAttention",
          component: _ => import("./views/cUser/goodsAttention.vue"),
          meta: {
            title: lang.meta.title21
          }
        },
        {
          path: "shopAttention",
          name: "shopAttention",
          component: _ => import("./views/cUser/shopAttention.vue"),
          meta: {
            title: lang.meta.title22
          }
        },
        {
          path: "footmark",
          name: "footmark",
          component: _ => import("./views/cUser/footmark.vue"),
          meta: {
            title: lang.meta.title23
          }
        },
        {
          path: "shippingAddress",
          name: "shippingAddress",
          component: _ => import("./views/cUser/address/shippingAddress.vue"),
          meta: {
            title: lang.meta.title24
          }
        },
        {
          path: "coupon",
          name: "coupon",
          component: _ => import("./views/cUser/coupon.vue"),
          meta: {
            title: lang.cDefault.menu14
          }
        }
      ]
    },
    {
      path: "/payment",
      name: "payment",
      component: _ => import("./views/cUser/payment.vue"),
      meta: {
        title: lang.meta.title25
      }
    },
    {
      path: "/order",
      name: "order",
      component: _ => import("./views/order/order.vue"),
      meta: {
        title: lang.meta.title26
      }
    },
    {
      path: "/addressDetail",
      name: "addressDetail",
      component: _ => import("./views/cUser/address/addressDetail.vue"),
      meta: {
        title: lang.meta.title27
      }
    },
    {
      path: "/supplier",
      component: _ => import("./views/supplier/Index.vue"),
      children: [
        {
          path: "/",
          component: _ => import("./views/supplier/defult.vue"),
          meta: {
            title: "B2B2C " + lang.meta.title12
          }
        },
        {
          path: "defult",
          name: "defult",
          component: _ => import("./views/supplier/defult.vue"),
          meta: {
            title: "Vancheen " + lang.meta.title12
          }
        },
        {
          path: "products",
          name: "products",
          component: _ => import("./views/supplier/Products.vue"),
          meta: {
            title: lang.meta.title28
          }
        },
        {
          path: "productClasses",
          name: "productClasses",
          component: _ => import("./views/supplier/ProductClasses.vue"),
          meta: {
            title: lang.meta.title29
          }
        },
        {
          path: "productImport",
          name: "productImport",
          component: _ => import("./views/supplier/ProductImport.vue"),
          meta: {
            title: lang.meta.title30
          }
        },
        {
          path: "productEdit",
          name: "ProductEdit",
          component: _ => import("./views/supplier/ProductEdit.vue"),
          props: r => {
            let props = {
              number: r.query.number,
              tburl: r.query.tburl
            };
            const id = r.query.id;
            if (id) {
              props.id = parseInt(id);
            }
            return props;
          },
          meta: {
            title: "Vancheen "+ lang.meta.title12
          }
        },
        {
          path: "productOrders",
          name: "productOrders",
          component: _ => import("./views/supplier/ProductOrders.vue"),
          meta: {
            title: lang.meta.title26
          }
        },
        {
          path: "productInfo",
          name: "productInfo",
          component: _ => import("./views/supplier/productInfo/index.vue"),
          meta: {
            title: lang.meta.title31
          }
        },
        {
          path: "carriageTemplates",
          name: "carriageTemplates",
          component: _ => import("./views/supplier/CarriageTemplates.vue"),
          meta: {
            title: "Vancheen " + lang.meta.title12
          }
        },
        {
          path: "carriageTemplate",
          name: "carriageTemplate",
          component: _ => import("./views/supplier/CarriageTemplate.vue"),
          props: route => ({ id: parseInt(route.query.id) }),
          meta: {
            title: "Vancheen " + lang.meta.title12
          }
        },
        {
          path: "productAnalysis",
          name: "productAnalysis",
          component: _ => import("./views/supplier/ProductAnalysis.vue"),
          meta: {
            title: lang.meta.title32
          }
        },
        {
          path: "financialTtatement",
          name: "financialTtatement",
          component: _ => import("./views/supplier/financial/FinancialtTatement.vue"),
          meta: {
            title: lang.meta.title33
          }
        },
        {
          path: "userManage",
          name: "UserManage",
          component: _ => import("./views/supplier/user/UserManage.vue"),
          meta: {
            title: lang.meta.title20
          }
        },
        {
          path: "companyInfo",
          name: "companyInfo",
          component: _ => import("./views/supplier/user/CompanyInfo.vue"),
          meta: {
            title: lang.meta.title34
          }
        },
        {
          path: "addCertificates",
          name: "addCertificates",
          component: _ => import("./views/supplier/AddCertificates.vue"),
          meta: {
            title: lang.meta.title35
          }
        }
      ],
      meta: {
        requireAuth: true,
        title: lang.meta.title36
      }
    },
    {
      path: "/contactCustomerService",
      name: "contactCustomerService",
      component: _ => import("./views/contactService/contactService.vue"),
      meta: {
        title: lang.meta.title37
      }
    },
    {
      path: "/serviceDetail",
      name: "serviceDetail",
      component: _ => import("./views/contactService/serviceDetail.vue"),
      meta: {
        title: lang.meta.title38
      }
    },
    {
      path: "/certification",
      name: "certification",
      component: _ => import("./views/supplier/Certification.vue"),
      meta: {
        requireAuth: true,
        title: "Vancheen " + lang.meta.title12
      }
    },
    {
      path: "/certification/:type",
      name: "certification",
      component: _ => import("./views/supplier/CertificationEdit.vue"),
      props: true,
      meta: {
        requireAuth: true,
        title: "Vancheen "  + lang.meta.title12
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: _ => import("./views/terms/Terms.vue"),
      meta: {
        title: "Vancheen "  + lang.meta.title39
      }
    },
    {
      path: "/agreement",
      name: "Agreement",
      component: () => import("./views/terms/Agreement.vue"),
      meta: {
        title: lang.meta.title40
      }
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () => import("./views/terms/Privacy.vue"),
      meta: {
        title: lang.meta.title41
      }
    },
    {
      path: "/shippingRules",
      name: "ShippingRules",
      component: () => import("./views/terms/ShippingRules.vue"),
      meta: {
        title: lang.meta.title42
      }
    },
    {
      path: "/aboutUs",
      name: "AboutUs",
      component: () => import("./views/terms/AboutUs.vue"),
      meta: {
        title: lang.meta.title43
      }
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: () => import("./views/feedback.vue"),
      meta: {
        title: lang.meta.title44
      }
    }
  ]
});
